import { isTargetElement } from './isTargetElement';
import { updateElementStroke } from './updateElementStroke';

import { DrawingShape } from '~/core/models';

export const processShapeElements =
  (activeShape?: DrawingShape) => (shape: DrawingShape) => {
    const isActive = shape.canvasObjectName === activeShape?.canvasObjectName;

    shape.fabricGroup
      .getObjects()
      .filter(isTargetElement)
      .forEach(updateElementStroke(isActive));
  };
